
import { Badge } from '@/components/ui/badge';

type Status = 'active' | 'inactive' | 'expired' | string;

interface StatusBadgeProps {
  status: Status;
}

const statusStyles = {
  active: 'bg-green-500/20 text-green-700 hover:bg-green-500/20',
  inactive: 'bg-gray-500/20 text-gray-700 hover:bg-gray-500/20',
  expired: 'bg-red-500/20 text-red-700 hover:bg-red-500/20',
} as const;

export function StatusBadge({ status }: StatusBadgeProps) {
  const formattedStatus = typeof status === 'string' ? status.toLowerCase() : 'inactive';
  const style = statusStyles[formattedStatus as keyof typeof statusStyles] || statusStyles.inactive;
  
  return (
    <Badge className={style}>
      {formattedStatus.charAt(0).toUpperCase() + formattedStatus.slice(1)}
    </Badge>
  );
}
